angular.module('admin')
  .controller('AgentImportClientsCtrl', ['$scope', '$state', 'UserService', 'HomeService', '$timeout', 'UtilService', 'HelperService'
  , function($scope, $state, UserService, HomeService, $timeout, utils, helpers){

    $scope.agentId =  $state.params.id;


    var parser = new HBParser('encompass');

    $scope.parseFile = function(e){
      $scope.$apply(function(){
        $scope.loading = true;
      });

      var csv;

      if(e && e.target && e.target.files)
        csv = e.target.files[0];

      if(!csv) throw('Error reading file');

      Papa.parse(csv, {
        header: true,
        skipEmptyLines: true,
        complete: function(results){

          var clients = parser.parse(results.data);
          clients = $scope.compactData(clients);

          $scope.$apply(function(){
            $scope.clients = clients;
            $scope.loading = false;
          }, 800);
        }
      });
    }

    $scope.uploadClients = function(){
      var args = {
        clients: $scope.clients,
        agentId: $scope.agentId
      };

      $scope.loading = true;

      HomeService.createManyHomes(args)
        .then(function(data){
          console.log(data);
          $scope.loading = false;
          $scope.clients = false;
          $scope.uploadResults = data;
        })
        .catch(function(e){
          console.log('Error', e);
        });
    }

    $scope.compactData = function(clients){
      return _.map(clients, function(row){
        var ret = {
          users: [],
          loans: [],
        };

        var home = _.pick(row.home, _.identity);
        var user1 = _.pick(row.user, _.identity);
        var user2 = _.pick(row.user2, _.identity);
        var loan = _.pick(row.loan, _.identity);

        ret.home = home;

        if(user1 && !_.isEmpty(user1))
          ret.users.push(user1);

        if(user2 && !_.isEmpty(user2))
          ret.users.push(user2);

        if(loan && !_.isEmpty(loan)){
          loan.source = 'lender';
          ret.loans.push(loan);
        }

        return ret;
      });
    };

    function groupErrors(failures){
      return _.groupBy(failures, function(failure){
        return failure.error.code;
      });
    };


    $scope.closeModal = function(){
      $scope.currentModal = null;
    };


}]);
